import { hasLicense } from "@sourcewhale/shared/src/assets/js/src/general/licenses";
import { userStore } from "@sourcewhale/shared/src/svelte/api-stores/user-store";
import { get, writable } from "svelte/store";
import { columns, defaultVisibilityByKind } from "./columns";
import { kindsToAnyOf, todoQueryLicenseMap } from "./todoKindLicenses";

export const todosQueryParamsStore = writable(null);

class ToDoQueryParams {
  #init = $state(false);

  columns = $state(columns);

  #order = $state([]);

  get order() {
    return this.#order;
  }

  set order(value) {
    this.reset();
    this.#order = value;
  }

  start = $state(0);

  length = $state(10);

  #search = $state({ value: "", regex: false });

  set search(value) {
    this.start = 0;
    this.#search = value;
  }

  get search() {
    return this.#search;
  }

  campaignType = $state(null);

  #status = $state("active");

  get status() {
    return this.#status;
  }

  set status(value) {
    if (value !== this.#status) {
      this.reset();
      this.#status = value;
      this.#displayFuture = false;
    }
  }

  #displayFuture = $state(false);

  get displayFuture() {
    return this.#displayFuture;
  }

  set displayFuture(value) {
    if (this.#displayFuture !== value) {
      this.reset();
      this.#displayFuture = value;
      this.#status = "active";
    }
  }

  #kind = $state(localStorage.getItem("selectedKind") || "phoneCall");

  get kind() {
    return this.#kind;
  }

  set kind(value) {
    this.reset();
    localStorage.setItem("selectedKind", value);
    this.#kind = value;
    this.search = { value: "", regex: false };

    // when selecting a new kind reset displayFuture + status
    this.displayFuture = false;
    this.status = "active";

    const on = defaultVisibilityByKind[this.#kind] || [];

    this.columns.forEach((col) => {
      col.visible = !!on.includes(col.name);
    });
  }

  #userIds = $state([]);

  get userIds() {
    return this.#userIds;
  }

  set userIds(value) {
    this.reset();
    this.#userIds = value;
  }

  campaignIds = $state([]);

  projectIds = $state([]);

  opportunityKinds = $state([]);

  toDoTypes = $state([]);

  #set() {
    const data = {
      columns: this.columns,
      order: this.order,
      start: this.start,
      length: this.length,
      search: this.search,
      campaignType: this.campaignType,
      status: this.status,
      kind: this.kind,
      displayFuture: this.displayFuture,
      userIds: this.userIds,
      campaignIds: this.campaignIds,
      projectIds: this.projectIds,
      opportunityKinds: this.opportunityKinds,
      toDoTypes: this.toDoTypes,
    };

    todosQueryParamsStore.set(data);
  }

  /**
   * Reset the API store (and pagination offset) - this retriggers the full
   * table skeleton loader and reloads data
   */
  reset(set = false) {
    todosQueryParamsStore.set(null); // trigger reset in API store
    if (set) this.#set(); // set back to current state
  }

  async init() {
    await userStore.once();
    const user = get(userStore);

    if (!kindsToAnyOf([this.#kind]).some((l) => hasLicense(user, l, true))) {
      const [kind] =
        Object.entries(todoQueryLicenseMap).find(([, anyOf]) =>
          anyOf.some((l) => hasLicense(user, l, true)),
        ) || [];
      if (kind) {
        this.kind = kind;
      } else {
        console.error("No suitable to-do kind found for user licenses");
        return;
      }
    }

    this.#init = true;
  }

  constructor() {
    const i = this.columns.findIndex((c) => c.orderable);
    this.order = i > -1 ? [{ column: i, dir: "desc" }] : [];

    this.kind = this.#kind; // trigger side effects

    $effect.root(() => {
      $effect(() => {
        if (this.#init) {
          this.#set();
        }
      });
    });
  }
}

export const todosQueryParams = new ToDoQueryParams();
